import React from 'react';
import styled from 'styled-components';

import { ApiBalanceHistoryEvent } from 'api/types';
import config from 'config';

import { convertApiBridge } from '../bridge/crossChainMapping';
import { getChainIcon } from '../chains/chainIcons/chainIcons';

const TableIcon = styled.img`
  height: 12px;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 1px;
  vertical-align: inherit;
`;

// type TransactionChainProps =
//   | { type: 'withdrawal'; bridgeTarget: string }
//   | { type: 'deposit'; bridgeSource: string }
//   | { type: 'pendingDeposit'; sourceChain: ChainsFromConfig }
//   | { type: 'unknown' };

export default function BalanceTransactionChain({
  transaction,
}: {
  transaction: ApiBalanceHistoryEvent;
}) {
  const bridgeTarget =
    transaction.type === 'withdrawal'
      ? convertApiBridge(transaction.bridgeTarget)
      : transaction.type === 'deposit'
      ? convertApiBridge(transaction.bridgeSource)
      : undefined;

  const chain =
    transaction.type === 'pendingDeposit'
      ? transaction.sourceChain
      : bridgeTarget?.targetChain;

  const chainIcon = chain ? getChainIcon(chain) : undefined;
  const chainName = chain
    ? config.chains[chain].chainNetwork ||
      chain ||
      bridgeTarget?.targetChainName
    : 'Unknown';

  return (
    <>
      {chainIcon && <TableIcon src={chainIcon} />}

      {chainName}
    </>
  );
}
